import React, { useState } from "react";
import { toast } from "react-toastify";
const emptyLoan = { loanType: "", amount: "", tenure: "", roi: "", emi: "" };
const emptyFee = { description: "", amount: "", status: "Pending" };
import { createInvoice } from "../../../services/AdminPortal/invoiceAPI";
export default function InvoiceForm({ onCancel, onSubmit }) {
  const [invoiceNumber, setinvoiceNumber] = useState(
    `LONO-${new Date().getFullYear()}-${Math.floor(
      Math.random() * 9000 + 1000
    )}`
  );
  const [invoiceDate, setInvoiceDate] = useState(
    new Date().toISOString().slice(0, 10)
  );
  const [dueDate, setDueDate] = useState("");
  const [billedTo, setBilledTo] = useState({
    name: "",
    address: "",
    phone: "",
    email: "",
  });
  const [loanSummary, setLoanSummary] = useState([{ ...emptyLoan }]);
  const [fees, setFees] = useState([{ ...emptyFee }]);
  const [totals, setTotals] = useState({
    totalInvoiceValue: "",
    paid: "",
    balanceDue: "",
  });
  const [logoFile, setLogoFile] = useState(null);
  const [qrFile, setQrFile] = useState(null);

  const addLoan = () => setLoanSummary([...loanSummary, { ...emptyLoan }]);
  const removeLoan = (i) =>
    setLoanSummary(loanSummary.filter((_, idx) => idx !== i));
  const addFee = () => setFees([...fees, { ...emptyFee }]);
  const removeFee = (i) => setFees(fees.filter((_, idx) => idx !== i));

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      invoiceNumber,
      invoiceDate,
      dueDate,
      billedTo,
      loanSummary,
      fees,
      totals,
      logoFile,
      qrFile,
    };

    try {
        console.log("hello")
      await createInvoice(payload);
      toast.success("Invoice created successfully!");
    //   onSubmit(payload);
      onCancel();
    } catch (err) {
      console.error(err);
      toast.error("Failed to create invoice!!!");
    }
  };
  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  const handleFileChange = async (e, setter) => {
    const file = e.target.files[0];
    if (file) {
      const base64 = await toBase64(file);
      setter(base64); // store as Base64 string
    }
  };

  return (
    <form
      className="bg-[#0d0d0d] p-6 rounded-lg shadow-lg text-white text-sm overflow-y-auto max-h-[90vh]"
      onSubmit={handleSubmit}
    >
      {/* Invoice Info */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="text-gray-400 text-sm block mb-1">
            Invoice Number
          </label>
          <input
            type="text"
            value={invoiceNumber}
            onChange={(e) => setinvoiceNumber(e.target.value)}
            className="w-full px-3 py-2 rounded bg-[#131313] text-white text-sm border border-[#444] focus:outline-none"
          />
        </div>
        <div>
          <label className="text-gray-400 text-sm block mb-1">
            Invoice Date
          </label>
          <input
            type="date"
            value={invoiceDate}
            onChange={(e) => setInvoiceDate(e.target.value)}
            className="w-full px-3 py-2 rounded bg-[#131313] text-white text-sm border border-[#444] focus:outline-none"
          />
        </div>
        <div>
          <label className="text-gray-400 text-sm block mb-1">Due Date</label>
          <input
            type="date"
            value={dueDate}
            onChange={(e) => setDueDate(e.target.value)}
            className="w-full px-3 py-2 rounded bg-[#131313] text-white text-sm border border-[#444] focus:outline-none"
          />
        </div>
        {/* <div>
          <label className="text-gray-400 text-sm block mb-1">
            Logo (optional)
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleFileChange(e, setLogoFile)}
            className="w-full text-gray-300"
          />
        </div> */}
      </div>

      <hr className="my-4 border-[#333]" />

      {/* Billed To */}
      <h3 className="font-semibold text-yellow-400">Billed To</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
        <input
          placeholder="Name"
          value={billedTo.name}
          onChange={(e) => setBilledTo({ ...billedTo, name: e.target.value })}
          className="px-3 py-2 rounded bg-[#131313] text-white border border-[#444]"
        />
        <input
          placeholder="Phone"
          value={billedTo.phone}
          onChange={(e) => setBilledTo({ ...billedTo, phone: e.target.value })}
          className="px-3 py-2 rounded bg-[#131313] text-white border border-[#444]"
        />
        <input
          placeholder="Email"
          value={billedTo.email}
          onChange={(e) => setBilledTo({ ...billedTo, email: e.target.value })}
          className="px-3 py-2 rounded bg-[#131313] text-white border border-[#444]"
        />
        <input
          placeholder="Address"
          value={billedTo.address}
          onChange={(e) =>
            setBilledTo({ ...billedTo, address: e.target.value })
          }
          className="px-3 py-2 rounded bg-[#131313] text-white border border-[#444]"
        />
      </div>

      <hr className="my-4 border-[#333]" />

      {/* Loan Summary */}
      <h3 className="font-semibold text-yellow-400">Loan & EMI Summary</h3>
      {loanSummary.map((ln, i) => (
        <div
          key={i}
          className="grid grid-cols-1 md:grid-cols-5 gap-2 items-end mt-2"
        >
          <input
            placeholder="Loan Type"
            value={ln.loanType}
            onChange={(e) => {
              const newA = [...loanSummary];
              newA[i].loanType = e.target.value;
              setLoanSummary(newA);
            }}
            className="px-3 py-2 rounded bg-[#131313] text-white border border-[#444]"
          />
          <input
            placeholder="Amount"
            value={ln.amount}
            onChange={(e) => {
              const newA = [...loanSummary];
              newA[i].amount = e.target.value;
              setLoanSummary(newA);
            }}
            className="px-3 py-2 rounded bg-[#131313] text-white border border-[#444]"
          />
          <input
            placeholder="Tenure"
            value={ln.tenure}
            onChange={(e) => {
              const newA = [...loanSummary];
              newA[i].tenure = e.target.value;
              setLoanSummary(newA);
            }}
            className="px-3 py-2 rounded bg-[#131313] text-white border border-[#444]"
          />
          <input
            placeholder="ROI"
            value={ln.roi}
            onChange={(e) => {
              const newA = [...loanSummary];
              newA[i].roi = e.target.value;
              setLoanSummary(newA);
            }}
            className="px-3 py-2 rounded bg-[#131313] text-white border border-[#444]"
          />
          <div className="flex gap-2">
            <input
              placeholder="EMI"
              value={ln.emi}
              onChange={(e) => {
                const newA = [...loanSummary];
                newA[i].emi = e.target.value;
                setLoanSummary(newA);
              }}
              className="px-3 py-2 rounded bg-[#131313] text-white border border-[#444] flex-1"
            />
            <button
              type="button"
              onClick={() => removeLoan(i)}
              className="text-xs px-3 py-2 bg-red-600 rounded text-white"
            >
              Del
            </button>
          </div>
        </div>
      ))}
      <div className="mt-2">
        <button
          type="button"
          onClick={addLoan}
          className="text-sm px-3 py-1 bg-[#2b2b2b] border border-[#444] rounded"
        >
          + Add Loan Row
        </button>
      </div>

      <hr className="my-4 border-[#333]" />

      {/* Fee Section */}
      <h3 className="font-semibold text-yellow-400">Fee & Charges Breakdown</h3>
      {fees.map((f, i) => (
        <div
          key={i}
          className="grid grid-cols-1 md:grid-cols-4 gap-2 items-end mt-2"
        >
          <input
            placeholder="Description"
            value={f.description}
            onChange={(e) => {
              const newA = [...fees];
              newA[i].description = e.target.value;
              setFees(newA);
            }}
            className="px-3 py-2 rounded bg-[#131313] text-white border border-[#444] col-span-2"
          />
          <input
            placeholder="Amount"
            value={f.amount}
            onChange={(e) => {
              const newA = [...fees];
              newA[i].amount = e.target.value;
              setFees(newA);
            }}
            className="px-3 py-2 rounded bg-[#131313] text-white border border-[#444]"
          />
          <select
            value={f.status}
            onChange={(e) => {
              const newA = [...fees];
              newA[i].status = e.target.value;
              setFees(newA);
            }}
            className="px-3 py-2 rounded bg-[#131313] text-white border border-[#444]"
          >
            <option>Pending</option>
            <option>Paid</option>
            <option>Overdue</option>
          </select>
          <div className="col-span-4 flex justify-end">
            <button
              type="button"
              onClick={() => removeFee(i)}
              className="text-xs px-3 py-2 bg-red-600 rounded text-white"
            >
              Del
            </button>
          </div>
        </div>
      ))}
      <div className="mt-2">
        <button
          type="button"
          onClick={addFee}
          className="text-sm px-3 py-1 bg-[#2b2b2b] border border-[#444] rounded"
        >
          + Add Fee Row
        </button>
      </div>

      {/* Totals */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
        <div>
          <label className="text-gray-400 text-sm block mb-1">
            Total Invoice Value
          </label>
          <input
            value={totals.totalInvoiceValue}
            onChange={(e) =>
              setTotals({ ...totals, totalInvoiceValue: e.target.value })
            }
            className="w-full px-3 py-2 rounded bg-[#131313] text-white border border-[#444]"
          />
        </div>
        <div>
          <label className="text-gray-400 text-sm block mb-1">Paid</label>
          <input
            value={totals.paid}
            onChange={(e) => setTotals({ ...totals, paid: e.target.value })}
            className="w-full px-3 py-2 rounded bg-[#131313] text-white border border-[#444]"
          />
        </div>
        <div>
          <label className="text-gray-400 text-sm block mb-1">
            Balance Due
          </label>
          <input
            value={totals.balanceDue}
            onChange={(e) =>
              setTotals({ ...totals, balanceDue: e.target.value })
            }
            className="w-full px-3 py-2 rounded bg-[#131313] text-white border border-[#444]"
          />
        </div>
      </div>

      {/* QR Upload */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <div>
          <label className="text-gray-400 text-sm block mb-1">
            QR Image (optional)
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleFileChange(e, setQrFile)}
            className="w-full text-gray-300"
          />
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex justify-between mt-6">
        <button
          type="button"
          onClick={onCancel}
          className="bg-[#2b2b2b] text-white px-4 py-2 rounded text-sm border border-[#444]"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="bg-yellow-400 text-black px-4 py-2 rounded text-sm font-semibold"
        >
          Save Invoice ✓
        </button>
      </div>
    </form>
  );
}
